import React from "react";
import {NomenclaturesIsDeletedPage} from "./NomenclaturesIsDeletedPage";
import {useNomenclaturesIsDeleted} from "./useNomenclaturesIsDeleted";

function NomenclaturesIsDeleted() {
  return <NomenclaturesIsDeletedPage {...useNomenclaturesIsDeleted()} />;
}

export default NomenclaturesIsDeleted;
